import { SavedPromptsProvider } from '~/modules/saved/providers/saved-prompts';

import { ToastProvider } from './toast';
import { CurrentThemeProvider } from './theme';
import { AuthProvider } from './auth';
import { IFCWithChildren } from '../interfaces/i-fc-with-childrent';

export const ProvidersHOC: IFCWithChildren = ({ children }) => {
  return (
    <CurrentThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <SavedPromptsProvider>{children}</SavedPromptsProvider>
        </AuthProvider>
      </ToastProvider>
    </CurrentThemeProvider>
  );
};
